// Global Instructions Rule Applied!
//
// Typography for cfg-authored guide prose.
//
// Guide bodies render inside a shadow root (ShadowRichHtml) so that content
// written by whoever edits cfg can never leak styles into the app — but that
// isolation cuts both ways: Tailwind and the AntD theme cannot reach inside
// either. This sheet is what the shadow root gets instead. It is deliberately
// small and deliberately code-authored: it is injected as a real <style> node,
// so it never passes through the HTML sanitizer.
//
// Colours are the theme's own (brand #4C90E9, AntD's text greys) rather than
// new values — "never hand-type a blue" applies here too.

export const HELP_ARTICLE_CSS = `
  :host { display: block; }
  * { box-sizing: border-box; }
  p, ul, ol { margin: 0 0 10px; }
  p:last-child, ul:last-child, ol:last-child { margin-bottom: 0; }
  p, li {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 13px;
    line-height: 1.65;
    color: rgba(0, 0, 0, 0.85);
  }
  ul, ol { padding-left: 20px; }
  li { margin-bottom: 4px; }
  strong { font-weight: 600; }
  em { font-style: italic; color: rgba(0, 0, 0, 0.65); }
  code {
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 12px;
    background: #f5f5f5;
    border: 1px solid #e8e8e8;
    border-radius: 3px;
    padding: 1px 5px;
    white-space: nowrap;
  }
  a { color: #4C90E9; text-decoration: none; }
  a:hover { text-decoration: underline; }
  .callout {
    border-left: 3px solid #4C90E9;
    background: #f5f9fe;
    padding: 8px 12px;
    margin: 10px 0;
    border-radius: 0 3px 3px 0;
  }
  .callout-warn { border-left-color: #faad14; background: #fffbe6; }
  .callout p { margin: 0; font-size: 12px; }
`
